export default "__VITE_ASSET__Bs0sz98l__"